import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchAcikAnketler } from '../services/anketService';
import '../pages/AnketlerPage.css';

export default function AnketDavetBanner() {
  const [davetler, setDavetler] = useState([]);

  useEffect(() => {
    let iptal = false;
    fetchAcikAnketler()
      .then((res) => {
        if (!iptal) setDavetler(res?.veri || []);
      })
      .catch(() => {
        if (!iptal) setDavetler([]);
      });
    return () => { iptal = true; };
  }, []);

  if (!davetler.length) return null;

  return (
    <div className="anket-banner">
      {davetler.map((d) => (
        <Link key={d.url} to={d.url}>{d.baslik}</Link>
      ))}
    </div>
  );
}
